import React from 'react';
import clsx from 'clsx';

interface Tag {
  title: string;
  color: string;
}

export interface CreativeCard {
  id?: string | number;
  title: string;
  description: string;
  datePosted: string;
  tags: Tag[];
  views: string;
  image?: string;
  sessionDetails?: any;
  contact?: any;
  actions?: string[];
}

interface MarketingCreativeCardProps {
  card: CreativeCard;
  onClick?: () => void;
}

const getBadgeColor = (color: string) => {
  return color === 'red' ? 'bg-red-600' : 'bg-green-600';
};

const MarketingCreativeCard: React.FC<MarketingCreativeCardProps> = ({ card, onClick }) => {
  return (
    <div
      key={card.id}
      onClick={onClick}
      className="w-[254px] h-[335px] flex flex-col bg-white border border-[#E5E5E5] rounded-[12px] cursor-pointer shadow-sm hover:shadow-md transition"
    >
      {/* Image Block */}
      <div
        className="relative w-full h-[254px] bg-black bg-opacity-[0.02] rounded-t-[11px] overflow-hidden"
        style={{
          backgroundImage: card.image ? `url(${card.image})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {/* LIVE/NEW Tags + Views */}
        <div className="absolute top-[14px] right-[14px] flex gap-[6px]">
          {card.tags?.map((tag, tIdx) => (
            <div
              key={tIdx}
              className={`flex items-center justify-center px-2 py-1 rounded-[4px] text-white text-[10px] font-semibold leading-[15px] tracking-[0.08em] uppercase ${
                tag.color === 'red' ? 'bg-[#B91C1C]' : 'bg-[#22C55E]'
              }`}
            >
              {tag.title}
            </div>
          ))}
          <div className="flex items-center justify-center px-2 py-1 rounded-[4px] bg-[#E5E5E5] text-[#171717] text-[10px] font-semibold leading-[15px] tracking-[0.08em] uppercase">
            {card.views ?? '0'} Views
          </div>
        </div>
      </div>

      {/* Content Block */}
      <div className="flex flex-col justify-between p-4 gap-4 border-t border-[#E7E5E4] h-[81px]">
        <div className="flex flex-col gap-[4px]">
          <h3 className="text-[16px] font-medium text-[#171717] leading-[24px] truncate">
            {card.title}
          </h3>
          <p className="text-[14px] font-normal text-[#737373] leading-[21px] truncate">
            {card.datePosted}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MarketingCreativeCard;
